import { Meta } from '@/src/components/common/Meta';
import JamTeam from '@/src/components/game/JamTeam/JamTeam';
import { useJamEventDetails } from '@/src/store/jam-event-details.context';
import { i18nKeys } from '@/src/utils/i18n.utils';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const JamEventTeamPage: React.FC = () => {
  const { t } = useTranslation();
  const { event } = useJamEventDetails();

  const eventTitle = event?.title ?? t(i18nKeys.meta.event.title);
  const pageTitle = `${t(i18nKeys.general.team)} | ${eventTitle}`;

  return (
    <>
      <Meta title={pageTitle} />
      <JamTeam />
    </>
  );
};
